import * as React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  Radio,
  FormControlLabel,
  Grid2,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  Card,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DateRangeOptions } from "../Utility/Constants";
import { getDisplayValue, showLoadingImage } from "../Utility/Utility";
import { useState } from "react";
import { getClinicalServices, getPrimaryClinicalServices } from "../API/FacilitySettingsApi";
import AuthContext from "../Context/AuthProvider";
import { getFacilityUsers } from "../API/UsersApi";
import { addNewService } from "../API/LinkedServicesApi";
import { CheckBox } from "@mui/icons-material";
import AvailableSlots from "../Appointments/AvailableSlots";
import { getAvailableSlots } from "../API/AppointmentsApi";
import { getDatesArray } from "../Utility/DateTimeUtility";
import { useSnackbar } from "../Utility/UserMessageContext";

export default function AddNewServiceDialog({
  openState,
  setOpenState,
  refreshServices,
  visitId,
  visitLocation,
  visitType,
  visitDate,
}) {
    const { auth } = React.useContext(AuthContext);
  const [availableServices, setAvailableServices] = useState();
  const [availableStaff, setAvailableStaff] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState();
  const [selectedStaffId, setSelectedStaffId] = useState();
  const [notes, setNotes] = useState();
  const [adding, setAdding] = useState();
  const [now, setNow] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(new Date());
  const {showSnackbar} = useSnackbar();
  

    React.useEffect(() => {
        const getAvailableStaff = async () => {
          var result = await getFacilityUsers(auth, {
              facilityId: auth.selectedFacility.id,
              roles: ["Physician"],
          });
          if(result?.isSuccess)
          {
            setAvailableStaff(result?.data);
          }
        };
    
        const setClinicalServices = async () => {
          const filters = {
            facilityId: auth.selectedFacility.id,
            visitType: visitType,
            }
          var result = await getClinicalServices(auth, filters);
          if (result.isSuccess) {
            console.log(result?.data);
            setAvailableServices(result?.data);
          } 
        };
        setClinicalServices();
        getAvailableStaff();
      }, [auth]);

      const refreshSlots = async (serviceId, staffId) => {
          setShowSpinner(true);
          const dates = getDatesArray(new Date(visitDate),1);
          //setDateRange(dates);
          // const serviceId = document.querySelector("#serviceSelector").value;
          // const physicianId = document.querySelector("#physicianSelector").value;
          var result = {};
      
          // setSelectedServiceId(serviceId);
          // setSelectedPhysicianId(physicianId);
          if (serviceId !== "" && staffId !== "") {
            result = await getAvailableSlots(
              dates,
              auth,
              staffId,
              serviceId
            );
            if (result?.isSuccess) {
              setAvailableSlots(result?.data);
            } else {
              setAvailableSlots();
              //setErrorMessage(result?.data);
              //errorToast.show();
            }
          } else {
            setSelectedTimeSlot();
          }
          setShowSpinner(false);
        };

      const OnAddNewService = async () => {
        setAdding(true);
        const result = await addNewService(auth, visitId, selectedServiceId, selectedStaffId, notes, selectedTimeSlot);
        if(result.isSuccess)
        {
            
            setOpenState(false);
            refreshServices();
        }
        else
        {
            showSnackbar(result?.data, "error");
        }
        setAdding(false);
      } 

      const renderAvailableSlots = () => {
        return (
          <Card variant="outlined" fullWidth sx={{ width:'100%', height: "150px", }}>
            <Grid2 size={12}>
              
                {showSpinner ? (
                  showLoadingImage()
                ) : (
                  <div class="col-12 g-0 d-flex justify-content-center">
                    {selectedStaffId !== "" && selectedServiceId !== "" ? (
                      <AvailableSlots
                        dateTimeSlots={availableSlots}
                        setTimeSlot={setSelectedTimeSlot}
                        disabled={adding}
                      ></AvailableSlots>
                    ) : (
                      <label
                        className="ms-1 
                fst-italic"
                      >
                        Select a service and a physician to view the available
                        slots.
                      </label>
                    )}
                  </div>
                )}
            </Grid2>
          </Card>
        );
      };
    

  return (
    <Dialog open={openState} fullWidth>
      <DialogTitle>Add New Service</DialogTitle>
      <DialogContent dividers>
        <Grid2 container size={12} spacing={2}>
          <Grid2 container size={12}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Service
              </InputLabel>
              <Select
                label="Available Services"
                value={selectedServiceId}
                disabled={adding}
                onChange={(e) => {
                  setSelectedServiceId(e.target.value);
                  refreshSlots(e.target.value, selectedStaffId);
                }}
              >
                {availableServices &&
                  availableServices?.map((s) => (
                    <MenuItem value={s.id}>
                      {s.name}, Fees Rs. {s.fees}, Duration {s.durationInMins}{" "}
                      Mins
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 container size={12} >
            <FormControl fullWidth>
              <InputLabel>Assign To</InputLabel>
              <Select
                value={selectedStaffId}
                label="Assign To"
                disabled={adding}
                onChange={(e) => {
                  setSelectedStaffId(e.target.value);
                  refreshSlots(selectedServiceId, e.target.value);
                }}
              >
                {availableStaff &&
                  availableStaff?.map((p) => (
                    <MenuItem value={p.id}>
                      {p.salutation} {p.firstName} {p.lastName}, {p.suffix}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 container size={12}>
            <TextField
              fullWidth
              label="Notes"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={notes}
              multiline
              minRows={3}
              maxRows={3}
              disabled={adding}
              onChange={(e) => {
                setNotes(e.target.value);
              }}
            ></TextField>
          </Grid2>
          {visitDate === dayjs().format("YYYY-MM-DD") && (
          <Grid2> 
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={adding}
                    checked={now}
                    onChange={(e) => {
                      setNow(e.target.checked);
                      if(e.target.checked)
                      {
                        setSelectedTimeSlot(new Date());
                      }
                      else{
                        setSelectedTimeSlot();
                      }
                    }}
                  />
                }
                label="Now or select a time from available slots."
              />
            </Grid2>
          )}
          <Grid2 container size={12}>
            {renderAvailableSlots()}
          </Grid2>
        </Grid2>
        
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenState(false)}
          variant="outlined"
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          loading={adding}
          onClick={OnAddNewService}
          variant="contained"
          color="secondary"
          disabled = {!selectedServiceId || !selectedStaffId || !selectedTimeSlot}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
